import React from "react";
import UAGLogo from "../../images/logo.png";
import { Link } from "react-router-dom";

const Logo = () => {
  return (
    <Link to={`${process.env.PUBLIC_URL}/`} className="logo-link">
      <img className="logo-light logo-img logo-img-dashboard" src={UAGLogo} alt="logo" />
      <img className="logo-dark logo-img logo-img-dashboard" src={UAGLogo} alt="logo" />
      <img className="logo-small logo-img logo-img-dashboard" src={UAGLogo} alt="logo" />
    </Link>
  );
};

export default Logo;
